// extracted by mini-css-extract-plugin
export default {"main":"_47b9139453 _3dded91508 _00813b3397 _9bf17fce55","title":"_6a9a48cb85"};